<template>
  <div>
    <el-tabs type="border-card" @tab-click="clickTab">
      <el-tab-pane class="paddingBody content" :label="$t('Tareas')">
        <center v-if="loadingAllDataRequired">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-row v-else>
          <el-col :md="24">
            <el-button :class="{
              intermitente:
                contract !== null &&
                inventory !== null &&
                Object.keys(inventory).length === 0,
            }" style="margin-right: 20px; color: white !important" @click="handleAddTask()" type="primary" size="small"
              icon="el-icon-plus">
              <b>Agregar tarea</b>
            </el-button>
          </el-col>

          <el-col v-if="
            contract !== null &&
            inventory !== null &&
            Object.keys(inventory).length === 0
          " :md="24" style="padding-left: 53px">
            <br />
            <img src="https://www.flaticon.es/svg/static/icons/svg/892/892687.svg" width="50" />
          </el-col>

          <el-col :md="24">
            <br />
            <el-alert style="border: 1px solid gray" v-if="
              contract !== null &&
              inventory !== null &&
              Object.keys(inventory).length === 0
            " type="info" show-icon :closable="false">
              <template>
                <div style="color: black; padding-left: 10px">
                  <b>INSTRUCCIONES PARA CREAR SU INVENTARIO DE RIESGOS</b>
                  <p>
                    Para comenzar a crear su Inventario de Riesgos en primera
                    instancia debe oprimir el botón <b>"Agregar Tarea"</b>,
                    luego debe asignar un nombre a la tarea y posteriormente
                    agregar los riesgos que usted estime necesarios. Recuerde
                    que puede utilizar riesgos estandarizados los cuales
                    <b>no requieren de una evaluación para aprobarse</b>, si el
                    riesgo estandarizado no se adapta a sus necesidades o
                    necesita añadir uno diferente a los que se encuentran en el
                    listado usted puede realizarlo creando un riesgo
                    personalizado y así añadir con mayor detalle sus
                    especificaciones, para la aprobación de un riesgo de este
                    tipo
                    <b>se requiere la evaluación de diferentes usuarios</b>,
                    estos dependerán del nivel MFL de su riesgo.
                  </p>
                </div>
              </template>
            </el-alert>
            <el-alert style="border: 1px solid orange" v-if="
              !haveEnvironmentalRisks &&
              contract !== null &&
              inventory !== null &&
              Object.keys(inventory).length !== 0
            " type="warning" show-icon :closable="false">
              <template>
                <div style="padding-left: 10px; color: black">
                  <b>Advertencia: La plataforma detecto que en la actualidad su inventario de riesgos no presenta
                    riesgos o aspectos medioambientales.</b>
                  <p>
                    Esto quiere decir, que mientras su inventario no cuente con riesgos o aspectos medioambientales, el
                    inventario no podrá ser enviado a fase de “Revisión”. Se recomienda incorporar los riesgos
                    mencionados si desea continuar con el proceso de aprobación de su inventario en plataforma.
                  </p>
                </div>
              </template>
            </el-alert>
          </el-col>

          <el-col :md="24">
            <el-table class="tasksTable" :data="tareasInventario" v-if="tareasInventario.length > 0" style="width: 100%"
              header-cell-class-name="header-cell-class-table-gray-2">
              <el-table-column type="index" align="center" width="50" label="N°" />
              <el-table-column prop="nombre" :label="$t('Nombre de la tarea')" />
              <el-table-column prop="ready" :label="$t('Información')" align="center" header-align="center" width="300">
                <template slot-scope="scope">
                  <el-tag class="tag" type="success" v-if="scope.row.riesgos">{{ scope.row.riesgos.length }} {{
                    $t("riesgos")
                  }}</el-tag>
                  <el-tag v-else type="warning">{{ $t("0 riesgos") }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" width="400" :label="$t('Operaciones')">
                <template slot-scope="scope">
                  <el-button type="info" size="small" @click="editRisks(scope.row)">{{ $t("Identificar riesgos") }}
                  </el-button>
                  <el-button type="danger" size="small" @click="deleteTask(scope.row)" icon="el-icon-delete" />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :before-close="handleClose" title="Participante en el análisis del inventario" width="40%" append-to-body
      :visible="dialogNewEvaluadorVisible">
      <center v-if="searchUser">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>
      <el-form v-else element-loading-text="Buscando Usuario..." element-loading-background="rgba(255, 255, 255)"
        :model="formEvaluador" label-position="top" ref="formEvaluador">
        <el-form-item label="RUT">
          <el-input v-model="formEvaluador.rut" class="with-help-box" auto-complete="on" />
          <el-popover class="help-box" placement="right" title="RUT" width="200" trigger="hover"
            :content="$t('Escriba el RUT del evaluador')">
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item label="Nombre Completo">
          <el-input v-model="formEvaluador.nombres" class="with-help-box" auto-complete="on" />
          <el-popover class="help-box" placement="right" :title="$t('Nombre')" width="200" trigger="hover"
            :content="$t('Escriba el Nombre Completo del evaluador')">
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item label="Apellido Paterno y Materno">
          <el-input v-model="formEvaluador.apellidos" class="with-help-box" auto-complete="on" />
          <el-popover class="help-box" placement="right" :title="$t('Apellidos Paterno y Materno')" width="200"
            trigger="hover" :content="$t('Escriba el apellido paterno y materno del evaluador')">
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item label="Cargo">
          <el-input v-model="formEvaluador.cargo" class="with-help-box" auto-complete="on" />
          <el-popover class="help-box" placement="right" :title="$t('Cargo')" width="200" trigger="hover" :content="
            $t('Escriba el Cargo del evaluador al momento de la evaluación')
          ">
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("Cancelar") }}</el-button>
        <el-button v-if="!isEdit" @click="addParticipante" type="primary">{{
          $t("Agregar")
        }}</el-button>
        <el-button type="primary" @click="modificarEvaluador()" v-else>{{
          $t("Modificar")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import uuid from "uuid/v4";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import inventoryRequirements from "@/mixins/inventoryRequirements_anual";
import MostrarContrato from "@/components/MostrarContrato.vue";
import { getMFL } from "@/utils/generalFunctions";

const isSettedAndHas = (obj, key) => obj[key] && obj[key].length;

export default {
  props: ["cambios"],
  mixins: [inventoryRequirements],
  components: {
    MostrarContrato,
    Circle9,
  },
  data() {
    return {
      loadingAllDataRequired: false,
      seguimiento: [],
      loading_seguimiento: false,
      render: 0,
      formEvaluador: {
        id: "",
        nombres: "",
        apellidos: "",
        rut: "",
        cargo: "",
      },
      searchUser: false,
      dialogNewEvaluadorVisible: false,
      selectedCustomProcedure: {},
      selectedTaskProcedure: {},
      selectedTaskId: null,
      window,
      isLoading: false,
      task: "",
      taskEditId: null,
      renameTask: "",
      saveLoading: false,
      isEdit: false,
    };
  },
  computed: {
    ...mapGetters({
      role: "role",
      inventario: "inventario_copy",
    }),
    cType() {
      return this.contract && this.contract.tipo_contrato;
    },
    isVendor() {
      if (this.role.admin) return false;
      if (this.role.empresa_id) return true;
      return false;
    },
    procedureRule() {
      return this.mel ? { mfl: 4, rrr: 10 } : { mfl: 3, rrr: 90 };
    },
    tasksThatNeedProcedure() {
      const ttnp = [];
      this.tareasInventario.forEach((t) => {
        if (this.needProcedure(t)) ttnp.push(t.id || t._id);
      });
      return ttnp;
    },
    contractId() {
      return this.contract && (this.contract._id || this.contract.id);
    },

    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    },
    tareasInventario() {
      if (!this.inventario.tareas || this.inventario.tareas == null) {
        return [];
      }
      return this.inventario.tareas;
    },
    haveEnvironmentalRisks() {
      let have = false;
      if (this.inventario && this.inventario.tareas) {
        this.inventario.tareas.forEach((tarea) => {
          if (tarea.riesgos) {
            tarea.riesgos.forEach((riesgo) => {
              if (
                riesgo.tipo &&
                riesgo.tipo.toLowerCase() === "medioambiente"
              ) {
                have = true;
              }
            });
          }
        });
      }
      return have;
    },
  },
  created() {
  },
  watch: {
    "formEvaluador.rut": function () {
      this.debounceInput();
    },
    inventario: {
      handler() {
        this.$store.dispatch(
          "setStatus",
          this.inventario.wasApproved === true &&
            [0, 1, "0", "1"].includes(parseInt(this.inventario.status))
            ? `${this.inventario.status}wasApproved`
            : this.inventario.status
        );
      },
    },
    contract: {
    },
  },
  methods: {
    ...mapActions(["setTitle", "setSubTitle", "setInventario"]),
    clickTab(tab) {
      if (tab.label === "Seguimiento") {
        this.getSeguimiento(this.inventory._id);
      }
    },
    getSeguimiento(id) {
      this.loading_seguimiento = true;
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .get(`/inventarios/getSeguimiento/${id}`, config)
        .then((response) => {
          self.seguimiento = response.data;
          self.loading_seguimiento = false;
        });
    },
    debounceInput: _.debounce(function () {
      if (this.isEdit === false) {
        this.searchUser = true;
        axios
          .get(`/usuarios/by_rut/${this.formEvaluador.rut}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            if (response.data.success !== false) {
              this.formEvaluador.id = response.data._id;
              this.formEvaluador.nombres = `${response.data.nombre}`;
              this.formEvaluador.apellidos = `${response.data.apellido}`;
              this.formEvaluador.rut = response.data.rut;
              this.searchUser = false;
            } else {
              this.formEvaluador.id = "";
              this.searchUser = false;
            }
          });
      }
    }, 1500),
    addParticipante() {
      if (this.formEvaluador.id === "") {
        this.formEvaluador.id = uuid();
      }
      this.$store.dispatch("addParticipante", this.formEvaluador);
      this.handleClose();
    },
    editDialogEvaluador(evaluador) {
      this.isEdit = true;
      this.formEvaluador = JSON.parse(JSON.stringify(evaluador));
      this.dialogNewEvaluadorVisible = true;
    },
    deleteEvaluador(evaluador) {
      this.$confirm(
        this.$t(
          "Estás a punto de eliminar a un evaluador. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.$store.dispatch("deleteParticipante", evaluador);
      });
    },
    modificarEvaluador() {
      this.$store.dispatch("editParticipante", this.formEvaluador);
      this.render = this.render + 1;
      this.handleClose();
    },
    needProcedure(task) {
      if (!isSettedAndHas(task, "riesgos")) return; // no trae riesgos o no tiene
      return !!task.riesgos.find((r) => {
        if (!isSettedAndHas(r, "impactos")) return false;
        const { mfl, factor_severidad, factor_probabilidad } = r.impactos[0];
        if (!(mfl && factor_severidad && factor_probabilidad)) return false;
        const rrr = factor_severidad * factor_probabilidad;
        return mfl >= this.procedureRule.mfl || rrr >= this.procedureRule.rrr;
      });
    },
    handleClose() {
      this.isEdit = false;
      this.formEvaluador = {
        id: "",
        nombres: "",
        apellidos: "",
        rut: "",
        cargo: "",
      };
      this.dialogNewEvaluadorVisible = false;
      this.task = "";
    },
    closeDialogTask() {
      this.renameTask = "";
      this.taskEditId = null;
    },
    editFormTask(task) {
      this.renameTask = task.nombre;
      this.taskEditId = task.id || task._id;
    },
    handleAddTask() {
      this.$store
        .dispatch("addTask", { task: this.task, anual: true })
        .then((res) => {
          this.$store.dispatch("addChange", {
            num: this.$store.getters.cambios.length + 1,
            id: res._id,
            tarea: this.task,
            riesgo: "---",
            descripcion: "Se crea nueva tarea",
            date: new Date(),
          });
          this.editRisks(res);
        });
      this.$notify.info({
        duration: 3000,
        title: "Atención",
        message: `${this.$t("Tarea")} "${this.task}" ${this.$t(
          "agregada exitosamente"
        )}`,
      });
    },
    editRisks(task) {
      task["anual"] = true;
      this.$store.dispatch("selectTask", task).then(() => {
        this.$store.dispatch("setStep", 2);
      });
    },
    deleteTask(task) {
      this.$confirm(
        this.$t(
          "Esto borrará la tareas y todos sus riesgos. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        task["anual"] = true;
        this.$store.dispatch("deleteTask", task).then(() => {
          this.$store.dispatch("addChange", {
            num: this.$store.getters.cambios.length + 1,
            id: this.$store.getters.cambios.length + 1,
            tarea: task.nombre,
            riesgo: "---",
            descripcion: "Se elimina tarea",
            date: new Date(),
          });
        });
      });
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    isRiskReady(risk) {
      let isReady = true;
      if (!risk.causas || risk.causas.length === 0) {
        return false;
      }
      if (!risk.impactos || risk.impactos.length === 0) {
        return false;
      }
      risk.causas.forEach((causa) => {
        if (
          !causa.controles_preventivos ||
          causa.controles_preventivos.length === 0
        ) {
          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }

      risk.impactos.forEach((impacto) => {
        if (
          !impacto.controles_mitigadores ||
          impacto.controles_mitigadores.length === 0
        ) {
          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }
      return true;
    },
  }, // methods
};
</script>

<style scoped>
.tasksTable {
  margin-top: 20px;
  /* max-height: 70vh;
  overflow: auto; */
}

.widthinputTask {
  width: 95%;
  margin-right: 5px;
}

.tag {
  margin-right: 10px;
}

.content {
  min-height: 50vh;
}

.img_pdf {
  margin-left: 10px;
  height: 30px;
  margin-bottom: 5px;
}

.img_pdf2 {
  height: 30px;
  vertical-align: middle;
  margin-left: 10px;
}

.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {

  0%,
  100% {
    box-shadow: 0px 0px 20px #ed7d31;
  }

  50% {
    box-shadow: 0px 0px 0px #ed7d31;
  }
}
</style>
